/*
If CPUserID is missing:
  1. Direct the user to vx-mystery-opt-in page.

If either of the QPLES parameters are missing:
  1. Show the appropriate error message with a link which updates the FF_Reset field in Silverpop record
     of Consumer database for the CPUserID to "Yes" and enter the user into Program ID 262165 Mystery
     Coupon Nurture Program. On Click, update Error message to "Check your inbox!"

If CPUserID and QPLES parameters are present, Link "Show Coupon" button to coupon page
*/

/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-undef */
/* eslint-disable one-var */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-expressions */
/* eslint-disable default-case */
/* eslint-disable object-shorthand */

import axios from 'axios';
import globals from '../../../components/common/globals';
import vxSpinner from '../../../components/common/vx-spinner/vx-spinner.vue';
import AnalyticsService from '../../../components/common/services/analytics-service';
import tableToForm from '../../../components/common/mixins/tableToForm-mixin';

export default {
  name: 'vx-mystery-referral-thank-you-mixin',
  components: { vxSpinner },
  mixins: [tableToForm],
  created: function() {
    this.siteName = this.globals.siteId === 'vanityfair' ? 'vanityfairnapkins' : this.globals.siteId;
    if (!this.siteName) { this.siteName = this.globals.siteId ? this.globals.siteId : 'marketingpages'; }

    const util = {
      parseQueryString: () => {
        if (window.location.search.length > 0) {
          const q = window.location.search.substring(1).split('&');
          if (q) {
            for (let i = 0; i < q.length; i++) {
              let P = q[i].split('='),
                key = decodeURIComponent(P[0]),
                value = decodeURIComponent(P[1]);
              this.queryString[key.toLowerCase()] = value;
            }
          }
        }
      },
      applyQueryStringToConfig: () => {
        for (const prop in this.config) {
          if (this.queryString[prop.toLowerCase()]) {
            this.config[prop] = this.queryString[prop.toLowerCase()];
          }
        }
      },
    };
    util.parseQueryString();
    util.applyQueryStringToConfig();
  },
  props: {
    content: {
      type: String,
    },
  },
  mounted() {
    // let siteName = this.globals.siteId === 'vanityfair' ? 'vanityfairnapkins' : this.globals.siteId;
    // if (!siteName) { siteName = this.globals.siteId ? this.globals.siteId : 'marketingpages'; }
    if (this.config.submitUrl.length === 0) {
      switch (this.config.formBehavior.toLowerCase()) {
        case 'optin':
        case 'optin-popup':
          this.config.submitUrl = `/gpcommercewebservices/v2/${this.siteName}/utilityforms/explicitoptin`;
          break;
        case 'optout':
          this.config.submitUrl = `/gpcommercewebservices/v2/${this.siteName}/utilityforms/explicitoptout`;
          break;
      }
    }
    if (this.config.getoptinstatusUrl.length === 0) {
      this.config.getoptinstatusUrl = `/gpcommercewebservices/v2/${this.siteName}/utilityforms/getoptstatus`;
    }
    if (this.config.opt_Attribution_Version.length === 0) {
      this.config.opt_Attribution_Version = this.config.intSource;
    }

    if (this.$el && this.$el.querySelector) {
      try {
        this.emailField = this.$el.querySelector('input[type="email"]');
        // this.gpFormErrorMsg = this.$el.querySelector('.GPformErrorMsg');
        // this.submitButton = this.$el.querySelector('.GPformButtonSubmit');
        if (this.config.formBehavior === 'optin-popup' && sessionStorage.getItem('popup') === null && document.cookie.indexOf('cpUserId') === -1 && !this.isFilteredPage()) {
          // Save data to sessionStorage
          sessionStorage.setItem('popup', 'true');

          this.popupCloseButton = this.$el.parentElement.querySelector('.popup-close');
          this.popupBox = this.$el.parentElement.querySelector('.popup-box');
          this.popupWrap = this.$el.parentElement.querySelector('.popup-wrap');
          setTimeout(this.showPopup, 5000);
        } else if (this.config.formBehavior === 'optin') {
          this.intervalID = setInterval(this.checkFormPos, 5000);
        }
      } catch (e) {
        console.log(`mounted: ${e.message}`);
      }
    }
  },
  data() {
    return {
      siteName: '',
      rendercount: 0,
      emailField: null,
      existingOpt: false,
      submitButton: {},
      queryString: [],
      gpFormErrorMsg: {},
      formErrors: '',
      submitButtonText: 'SUBMIT',
      submitButtonTextWaiting: 'SUBMIT',
      submitButtonTextWorking: 'WORKING...',
      formSubmitting: false,
      popupCloseButton: {},
      popupBox: {},
      popupWrap: {},
      analyticsService: new AnalyticsService(),
      globals,
      hasSpinner: false,
      popupEmailClicked: false,
      popupZipClicked: false,
      optinEmailClicked: false,
      optinZipClicked: false,
      findingSubmitErrors: false,
      successfulSubmit: false,
      intervalID: {},
      config: {
        formName: '.GPform',
        formBehavior:
          'optin' /* 'optout', 'passthru', 'optin-popup', 'optin-sticky', 'optionalopt' */,
        triggerType: 'click',
        trigger: '.fpdp-btn',
        enableBriteVerify: true /* false */,
        submitUrl: '',
        targetType: 'url',
        thanksTarget: '/save/paper-towel-coupons/thanks',
        galleryTarget: '/save/paper-towel-coupons/gallery?cpuserid=',
        optoutTarget: '/opt-out/success',
        passthruTarget: '' /* Target URL for pass thru forms */,
        getoptinstatusUrl: '',
        preCheckOptStatus: true,
        intSource: '',
        opt_Attribution_Version: '',
        bvapi: '',
        debug: false,
        initialized: false,
        authUrl: '/authorizationserver/oauth/token?client_id=mobile_android&client_secret=secret&grant_type=client_credentials',
        urlPrefix: '',
        auth_token: '',
        spprograms: '',
        spfieldmap: '',
        resetForm: false,
      },
    };
  },

  methods: {
    GPisValidEmailAddress() {
      // called by GPFieldValidate
      // if (!this.emailField) { return false; }

      let email = this.emailField.value ? this.emailField.value : this.emailField;
      if (email.length <= 4) return false;

      if (email[0] === ':') email = email.substr(1);

      const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      return pattern.test(email);
    },
    DisableSubmit() {
      if (this.submitButton) {
        this.formSubmitting = true;
        this.submitButtonText = this.submitButtonTextWorking;
        // this.submitButton.setAttribute('disabled', true);
        // this.submitButton.setAttribute('data-enabled-value', this.submitButton.getAttribute('value'));
        // this.submitButton.setAttribute('value', 'WORKING...');
        if (this.$refs.spinner) {
          this.$refs.spinner.showSpinner();
        }
      }
    },
    EnableSubmit() {
      if (this.submitButton) {
        this.formSubmitting = false;
        this.submitButtonText = this.submitButtonTextWaiting;
        // this.submitButton.removeAttribute('disabled');
        // this.submitButton.setAttribute('value', this.submitButton.getAttribute('data-enabled-value'));
        // this.submitButton.removeAttribute('data-enabled-value');
        if (this.$refs.spinner) {
          this.$refs.spinner.hideSpinner();
        }
      }
    },
    GPsubmitForm(e) {
      // Button handler
      e.preventDefault();
      let brands = [this.globals.siteId];
      this.resetForm = true;
      let errorCount = 0;
      const fields = this.$el.querySelectorAll('input, select, textarea');
      this.findingSubmitErrors = true;
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        errorCount += this.GPFieldValidate(element);

        let fieldName = element.getAttribute('name');
        fieldName = fieldName ? fieldName.toLowerCase() : '';
        if (fieldName === 'brands' && element.value) {
          brands = element.value.split(',');
        }
      }
      this.findingSubmitErrors = false;

      if (errorCount < 1) {
        this.DisableSubmit();
        this.SendFormData();
      }
    },
    addClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      if (classes.indexOf(className) === -1) {
        classes.push(className);
        // eslint-disable-next-line no-param-reassign
        el.className = classes.join(' ');
      }
    },
    hasClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      return classes.indexOf(className) > -1;
    },
    removeClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      const ret = [];
      for (let i = 0; i < classes.length; i++) {
        let e = classes[i];
        if (e !== className) {
          ret.push(e);
        }
      }
      // eslint-disable-next-line no-param-reassign
      el.className = ret.join(' ');
    },
    GPFieldValidate(e) {
      // called by GPsubmitForm, radioSelection
      const el = e.target ? e.target : e;
      if (!(el && el.getAttribute('validation'))) { // && el.is(':visible')
        return 0;
      }

      let validation = el.getAttribute('validation');
      validation = validation ? validation.toLowerCase() : '';

      this.removeClass(el, 'GPformError');
      el.setAttribute('data-error-msg', '');

      let errorMessage = '';

      if (validation.indexOf('required') > -1
          && (el.value === '')) { // || (el.is(':checkbox') && el.is(':checked')))) {
        errorMessage = `${el.getAttribute('name')} - Required field missing`;
        if (this.findingSubmitErrors) {
          this.analyticsService.trackMarketingFormPost({
            event: 'error',
            action: 'missing field',
            label: `${this.config.formBehavior} : ${errorMessage}`,
          });
        }
      }


      if (validation.indexOf('zip') > -1 &&
        (el.value.length < 5 || !/^\d{5}(?:[-\s]\d{4})?$/.test(el.value))) {
        // checks if zip is at least 5 digits, no
        errorMessage = 'Zip Code is not valid';
        if (this.findingSubmitErrors) {
          this.analyticsService.trackMarketingFormPost({
            event: 'error',
            action: 'invalid zipcode',
            label: `${this.config.formBehavior} : ${errorMessage}`,
          });
        }
        this.zipFieldEdited = this.zipFieldEdited ? this.zipFieldEdited : !this.zipFieldEdited;
      }

      if (validation.indexOf('phone') > -1) {
        el.setAttribute('maxlength', '10');
        el.value = el.value.replace(/[^0-9.]/g, '');
        if (el.value.length > 10) {
          errorMessage = 'Phone is not valid';
          if (this.findingSubmitErrors) {
            this.analyticsService.trackMarketingFormPost({
              event: 'error',
              action: 'invalid phone',
              label: `${this.config.formBehavior} : ${errorMessage}`,
            });
          }
        }
      }

      if (validation.indexOf('checkbox') > -1) {
        if (!el.checked) {
          errorMessage = 'Giant consent not checked';
          if (this.findingSubmitErrors) {
            this.analyticsService.trackMarketingFormPost({
              event: 'error',
              action: 'unchecked checkbox',
              label: `${this.config.formBehavior} : ${errorMessage}`,
            });
          }
        }
      }

      if (validation.indexOf('email') > -1 && el.value !== '') {
        if (!this.GPisValidEmailAddress(el.value)) {
          errorMessage = 'Email isn\'t valid.';
          if (this.findingSubmitErrors) {
            this.analyticsService.trackMarketingFormPost({
              event: 'error',
              action: 'invalid email',
              label: `${this.config.formBehavior} : ${errorMessage}`,
            });
          }
        }
        this.emailFieldEdited = this.emailFieldEdited ? this.emailFieldEdited : !this.emailFieldEdited;
      }

      if (errorMessage) {
        this.addClass(el, 'GPformError');
        el.setAttribute('data-error-msg', errorMessage);
      }

      this.ShowErrors();

      if (errorMessage) {
        return 1;
      }
      return 0;
    },
    SendFormData() {
      const formData = {};
      formData.existing_opt = this.existingOpt;
      const fields = this.$el.querySelectorAll('input, select, textarea');
      for (let i = 0; i < fields.length; i++) {
        let element = fields[i];
        let fieldName = element.getAttribute('name');
        fieldName = fieldName ? fieldName.toLowerCase() : '';
        if (fieldName && element.value && element.type.toLowerCase() !== 'submit') {
          if (fieldName === 'opt-in' && element.value === 'on') {
            formData['opt-in'] = 1;
          } else {
            formData[fieldName] = element.value;
          }
          if (this.queryString.indexOf(fieldName) > -1) {
            formData[fieldName] = this.queryString[fieldName];
          }
          if (fieldName === 'email') {
            const email = formData[fieldName];
            // The ":" prefix is a way to let the user bypass the BriteVerify call
            if (email[0] === ':') {
              formData[fieldName] = email.substr(1);
            }
          }
        }
      }
      if (!formData.brands) {
        formData.brands = this.globals.siteId.toLowerCase();
      }
      if (!formData.referring_url) {
        formData.referring_url = window.location.href;
      }
      if (!formData.int_source && this.config.intSource) {
        formData.int_source = this.config.intSource;
      }
      if (!formData.spprograms && this.config.spprograms) {
        formData.spprograms = this.config.spprograms;
      }
      if (!formData.spfieldmap && this.config.spfieldmap) {
        formData.spfieldmap = this.config.spfieldmap;
      }
      // if (formData['opt-in'] && formData['opt-in'] === 'on') {
      //   formData['opt-in'] = 1;
      //   if (this.config.submitUrl.indexOf('explicitoptin') === -1) {
      //     this.config.submitUrl += '/explicitoptin';
      //     this.config.formBehavior = 'optin';
      //   }
      // }
      this.GetAuthToken((success) => {
        if (success) {
          // eslint-disable-next-line prefer-template
          axios.post(this.config.urlPrefix + this.config.submitUrl, this.ObjectToQueryString(formData), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `bearer ${this.config.access_token}` } })
            .then(this.handleSendFormDataResponse)
            .catch(this.handleSendFormDataError);
        }
      });
    },
    GetAuthToken(callback) {
      const self = this;
      if (this.config.access_token) {
        if (callback) {
          callback.call(self, true);
        }
      } else {
        // eslint-disable-next-line prefer-template
        axios.post(this.config.urlPrefix + this.config.authUrl)
          .then((response) => {
            if (response && response.data && response.data.access_token) {
              this.config.access_token = response.data.access_token;
              if (callback) {
                callback.call(self, true);
              }
            } else {
              this.handleSendFormDataError.call('The server is unable to accept this form post at this time.');
            }
          })
          .catch(this.handleSendFormDataError);

      // https://localhost:9002/authorizationserver/oauth/token?client_id=mobile_android&client_secret=secret&grant_type=client_credentials
      /*
        {
            "access_token": "e13b0ab7-b93a-4fa0-b38d-b1c05e2b04aa",
            "token_type": "bearer",
            "expires_in": 42074,
            "scope": "basic openid"
        }
      */
      }
    },
    handleSendFormDataError(errorMessage) {
      let errorMessageInternal = 'There was a problem submitting the form. Please try again.';
      this.analyticsService.trackMarketingFormPost({
        event: 'error',
        action: 'view',
        label: `${this.config.formBehavior} : ${errorMessageInternal}`,
      });
      if (errorMessage) {
        errorMessageInternal = errorMessage;
      }

      this.EnableSubmit();
      if (errorMessageInternal) {
        this.emailField.setAttribute('data-error-msg', errorMessageInternal);
        this.ShowErrors();
      }
    },
    handleSendFormDataResponse(response) {
      const data = JSON.parse(response.data);
      if (data.results && typeof data.results.success === 'string') { data.results.success = data.results.success.toLowerCase() === 'true'; }

      if (!data.results.success) {
        if (data.results.error.length > 0) {
          this.handleSendFormDataError(data.results.error); // .join('</br>')
        } else {
          this.handleSendFormDataError();
        }
        return;
      }

      let cpUserId = '';
      if (data.results.cpuserid) {
        cpUserId = data.results.cpuserid;
        // set cookie to expire in 10 years (HL)
        let CookieDate = new Date();
        CookieDate.setFullYear(CookieDate.getFullYear() + 10);
        document.cookie = `cpUserId=${cpUserId};expires=${CookieDate.toUTCString()}; path=/`;
      }

      let analyticsCallbackHandled = false;
      const self = this;
      const analyticsCallback = function() {
        // gets called for each GTM tag
        if (analyticsCallbackHandled) {
          return;
        }
        analyticsCallbackHandled = true;

        self.EnableSubmit();
        if (self.resetForm) {
          self.$refs.viewQplesErrModal.close();
          self.$refs.viewEmailModal.open();
        } else if (self.config.targetType === 'url') {
          // document.location = self.existingOpt ? (self.config.galleryTarget + cpUserId) : self.config.thanksTarget;
          document.location = self.config.thanksTarget;
        } else if (self.config.targetType === 'element') {
          if (self.$el.querySelector('.campaignOptForm')) {
            self.$el.querySelector('.campaignOptForm').style.margin = '5rem';
          }
          self.$el.querySelector(self.config.thanksTarget).style.display = 'block';
          document.querySelector('.FormView').scrollIntoView();
          self.$el.querySelector('.FormView').style.display = 'none';
        }
      };
      switch (this.config.formBehavior) {
        case 'optin-popup': this.analyticsService.trackMarketingFormPost({
          event: 'promotionClick',
          action: 'submit',
          label: this.existingOpt ? 'existingopt' : 'newopt',
          ecommerce: {
            promoClick: {
              promotions: [{
                creative: this.config.formBehavior,
                name: 'form|optin popup',
                position: document.title,
                id: this.config.opt_Attribution_Version,
              }],
            },
          },
          eventCallback: analyticsCallback,
        });
          break;
        case 'optin':
        case 'optin-sticky': {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'submit',
            label: this.existingOpt ? 'existingopt' : 'newopt',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: 'form|optin',
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
            eventCallback: analyticsCallback,
          });
          break;
        } case 'optionalopt': {
          let gaLabel = this.existingOpt ? 'existingopt' : 'newopt';
          let gaCreative = this.config.formBehavior;
          // other logic
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'submit',
            label: gaLabel,
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: gaCreative,
                  name: 'form|GiantsTakeAction',
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
            eventCallback: analyticsCallback,
          });
          break;
        } case 'optout': {
          this.analyticsService.trackMarketingFormPost({
            eventCategory: 'optoutform',
            eventAction: 'submit',
            eventLabel: 'optout',
            event: 'fireTags',
            cpUserId: cpUserId,
            eventCallback: analyticsCallback,
          });
          break;
        } default: {
          this.analyticsService.trackMarketingFormPost({
            eventCategory: 'gpform',
            eventAction: 'submit',
            eventLabel: 'passthru',
            event: 'fireTags',
            cpUserId: cpUserId,
            eventCallback: analyticsCallback,
          });
          break;
        }
      }
    },
    ObjectToQueryString(object) {
      if (object) {
        return Object.keys(object).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
      }
      return '';
    },
    GetUserOptInStatus(callback) {
      const email = this.emailField.value;
      if (email.length > 0 && email[0] === ':') {
        this.email = email.substr(1);
      }
      this.GetAuthToken((success) => {
        if (success) {
          // eslint-disable-next-line prefer-template
          axios.post(this.config.urlPrefix + this.config.getoptinstatusUrl, this.ObjectToQueryString({
            email: email,
            brands: this.globals.siteId,
          }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `bearer ${this.config.access_token}` } })
            .then((response) => {
              if (callback) {
                callback.call(this, JSON.parse(response.data));
              }
            })
            .catch(() => {
              if (callback) {
                callback.call(this, { success: false });
              }
            });
        }
      });
    },
    ValidateBriteVerify(callback) {
      if (typeof this.config.bvapi === 'undefined') {
        callback.call(this, true);
        return;
      } else if (this.config.bvapi.length === 0) {
        callback.call(this, true);
        return;
      } else if (this.emailField.value[0] === ':') {
        callback.call(this, true);
        return;
      }
      // This needs to be replaced by https://www.npmjs.com/package/axios-jsonp
      jQuery.ajax({
        type: 'POST',
        url: 'https://bpi.briteverify.com/emails.json',
        data: {
          username: this.config.bvapi,
          address: this.emailField.value,
        },
        jsonp: 'callback',
        dataType: 'jsonp',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        encode: true,
        async: false,
        success: function(response) {
          if (
            response &&
            response.status !== 'invalid' &&
            response.status !== 'unknown' &&
            response.status !== 'accept_all' &&
            response.disposable !== 'true'
          ) {
            callback.call(this, true);
          } else {
            callback.call(this, false);
          }
        },
        error: function(response) {
          console.error(response);
          // Briteverify threw an error, so we will ignore it
          // and not stop the user from proceeding
          callback.call(this, true);
        },
      });
    },
    ShowErrors() {
      const out = [];
      const errors = this.$el.querySelectorAll('[data-error-msg]');
      for (let i = 0; i < errors.length; i++) {
        let el = errors[i];
        if (el.hasAttribute('data-error-msg')) {
          out.push(el.getAttribute('data-error-msg'));
        }
      }
      let result = [];
      for (let i = 0; i < out.length; i++) {
        if (out[i].length) { result.push(out[i]); }
      }
      this.formErrors = result.join('<br/>');
      // this.gpFormErrorMsg.innerHTML = result.join('<br/>');
    },
    showPopup() {
      this.popupWrap.style.display = 'block';
      setTimeout(() => {
        this.popupWrap.style.opacity = 1;
        this.popupBox.style.transform = 'translate(-50%, -50%) scale(1)';
      }, 10);
      this.analyticsService.trackMarketingFormPost({
        event: 'promotionView',
        action: 'view',
        label: 'impression',
        ecommerce: {
          promoView: {
            promotions: [{
              creative: this.config.formBehavior,
              name: 'form|optin popup',
              position: document.title,
              id: this.config.opt_Attribution_Version,
            }],
          },
        },
      });
    },
    isFilteredPage() {
      const excludedPages = [
        '/save',
        '/thanks',
        '/gallery',
        '/cart',
        '/checkout',
        '/covid',
        '/opt-out',
      ];

      const includePages = [
        '/orderConfirmation',
      ];
      for (let i = 0; i < includePages.length; i++) {
        if (location.href.indexOf(includePages[i]) > 0) {
          return false;
        }
      }
      for (let i = 0; i < excludedPages.length; i++) {
        if (location.href.indexOf(excludedPages[i]) >= 0) {
          return true;
        }
      }

      return false;
    },

    hidePopup() {
      setTimeout(() => { this.popupWrap.style.display = 'none'; }, 500);
      this.popupWrap.style.transition = 'all ease .5s';
      this.popupBox.style.transform = 'translate(-50%, -50%) scale(0.5)';
      this.popupWrap.style.opacity = 0;
      const successfulSubmit = this.$el.querySelector('.ThanksView').style.display === 'block';
      const label = successfulSubmit ? 'ClosePopUp-Success' : 'ClosePopUp';

      this.analyticsService.trackMarketingFormPost({
        event: 'promotionClick',
        action: 'engagement',
        label: label,
        ecommerce: {
          promoClick: {
            promotions: [{
              creative: this.config.formBehavior,
              name: 'form|optin popup',
              position: document.title,
              id: this.config.opt_Attribution_Version,
            }],
          },
        },
      });
    },

    radioSelection(e) {
      const el = e.target ? e.target : e;
      const sibEls = el.parentElement.childNodes;
      for (let i = 0; i < sibEls.length; i++) {
        if (sibEls[i].type === 'hidden') {
          sibEls[i].value = el.value;
          this.GPFieldValidate(sibEls[i]);
          break;
        }
      }
    },

    emailInputClick() {
      let pushData = false;
      if (!this.optinEmailClicked || !this.popupEmailClicked) {
        let name = '';
        if (this.config.formBehavior.toLowerCase() === 'optin-popup' && !this.popupEmailClicked) {
          name = 'form|optin popup';
          this.popupEmailClicked = true;
          pushData = true;
        } else if (this.config.formBehavior.toLowerCase() === 'optin' && !this.optinEmailClicked) {
          name = 'form|optin';
          this.optinEmailClicked = true;
          pushData = true;
        } else {
          pushData = false;
        }

        if (pushData) {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'engagement',
            label: 'email',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: name,
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
          });
        }
      }
    },

    zipInputClick() {
      let pushData = false;
      if (!this.optinZipClicked || !this.popupZipClicked) {
        let name = '';
        if (this.config.formBehavior.toLowerCase() === 'optin-popup' && !this.popupZipClicked) {
          name = 'form|optin popup';
          this.popupZipClicked = true;
          pushData = true;
        } else if (this.config.formBehavior.toLowerCase() === 'optin' && !this.optinZipClicked) {
          name = 'form|optin';
          this.optinZipClicked = true;
          pushData = true;
        } else {
          pushData = false;
        }

        if (pushData) {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'engagement',
            label: 'zipcode',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: name,
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
          });
        }
      }
    },
    checkFormPos() {
      let elementBoundingBox = this.$el.getBoundingClientRect();
      let elementTopY = elementBoundingBox.top;
      let elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
      let inview = elementTopY >= 0 && elementBottomY <= Math.min(document.documentElement.clientHeight, window.innerHeight || 0);

      if (inview) {
        this.analyticsService.trackMarketingFormPost({
          event: 'promotionView',
          action: 'view',
          label: 'impression',
          ecommerce: {
            promoView: {
              promotions: [{
                creative: this.config.formBehavior,
                name: 'form|optin',
                position: document.title,
                id: this.config.opt_Attribution_Version,
              }],
            },
          },
        });
        clearInterval(this.intervalID);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-referral-thank-you/vx-mystery-referral-thank-you-mixin.js